'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _PasswordControl = require('../../../lib/ui/PasswordControl');

var _PasswordControl2 = _interopRequireDefault(_PasswordControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterCredentials = function EnterCredentials(element) {
  var _this = this;

  _classCallCheck(this, EnterCredentials);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Uw PRIM account'
  });

  var checkCredentials = function checkCredentials() {
    if (!_this.username.getValue() || !_this.password.getValue()) {
      alert('Vul uw gebruikersnaam en wachtwoord in.');
      return;
    }

    window.PRIM.dataAccess.setCredentials(_this.username.getValue(), _this.password.getValue());
    window.PRIM.dataAccess.externalStatus().then(function (status) {
      switch (status) {
        case 'invalid':
          alert('PRIM account gegevens zijn niet correct. Probeer het opnieuw.');
          break;
        case 'exists':
          //alert('PRIM account gegevens zijn correct en zullen voortaan gebruikt worden. Deze kunt u later wijzigen bij instellingen.')
          //window.PRIM.saveCredentials(this.username.getValue(), this.password.getValue())
          window.PRIM.navigate('/sync/');
          break;
        default:
          window.PRIM.setLicense(status);
          //alert('PRIM account gegevens zijn correct en zullen voortaan gebruikt worden. Deze kunt u later wijzigen bij instellingen.')
          //window.PRIM.saveCredentials(this.username.getValue(), this.password.getValue())
          window.PRIM.session.password = _this.password.getValue();

          if (window.PRIM.License.isDemo) {
            alert('U logt in met een PRIM demonstratie account. Dit account biedt u de mogelijkheid om PRIM uit te proberen. Er zullen echter geen gegevens worden bewaard. Voer daarom geen gegevens die belangrijk voor u zijn.');
            addEventListener('beforeunload', function (e) {
              e.returnValue = 'U verlaat de demonstratieversie van PRIM. Eventuele ingevoerde gegevens zijn niet opgeslagen. Weet u het zeker?';
              return e.returnValue;
            });
          }

          window.PRIM.navigate('/sync/');
          break;
      }
    }, function (e) {
      alert('PRIM account gegevens konden niet gecontroleerd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.');
    });
  };

  var div = document.createElement('div');
  div.className = 'viewport';

  var p = document.createElement('p');
  p.innerHTML = 'Om in te loggen, voer hieronder uw PRIM account gegevens in.';

  var fieldset = document.createElement('fieldset');
  var legend = document.createElement('legend');
  legend.innerHTML = 'Account gegevens';
  fieldset.appendChild(legend);

  this.username = new _TextControl2.default(fieldset, { label: 'PRIM gebruikersnaam' });
  this.password = new _PasswordControl2.default(fieldset, { label: 'PRIM wachtwoord' });

  var button = document.createElement('button');
  button.innerHTML = 'Inloggen';
  button.onclick = checkCredentials;

  /*let buttonPrevious = document.createElement('button')
  buttonPrevious.innerHTML = 'Vorige'
  buttonPrevious.onclick = () => {
    window.PRIM.navigate('/welcome/')
  }*/

  div.appendChild(p);
  div.appendChild(fieldset);

  div.appendChild(button);
  //div.appendChild(buttonPrevious)
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EnterCredentials;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/EnterCredentials.js
// module id = 74
// module chunks = 0